$('.card_video picture').click(function(){
    $(this).toggleClass('d-none');
})